import { HelperResult, User } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useUser, useUpdate: useUpdateUser } = getCRUDHooks<User>({
  entityName: 'users',
  getHelper: () => clientApi.getOCClient().helpers.user.users,
  update: (
    user: Partial<User>,
    { userId, context }: { userId: number; context: string }
  ): HelperResult<User> =>
    clientApi
      .getOCClient()
      .helpers.user.users.partialUpdate(userId, user, false)
      .setHeader('X-Request-Context', context)
      .execute(),
});

export { useUser, useUpdateUser };
